(() => {
  const OPEN_CLASS = 'is-open';
  const VISIBLE_CLASS = 'is-visible';
  const BODY_LOCK = 'cfd-is-open';

  function initDrawer() {
    const drawer = document.getElementById('CfdDrawer');
    const overlay = document.querySelector('[data-cfd-overlay]');
    if (!drawer || !overlay) return;

    const openBtns = document.querySelectorAll('[data-cfd-open]');
    const closeBtns = document.querySelectorAll('[data-cfd-close]');

    function open() {
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add(OPEN_CLASS);
      overlay.classList.add(OPEN_CLASS);
      // allow display:block to render before animating opacity
      requestAnimationFrame(() => overlay.classList.add(VISIBLE_CLASS));
      document.body.classList.add(BODY_LOCK);
      openBtns.forEach(b => b.setAttribute('aria-expanded', 'true'));
      drawer.focus();
    }

    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove(OPEN_CLASS);
      overlay.classList.remove(VISIBLE_CLASS);
      document.body.classList.remove(BODY_LOCK);
      openBtns.forEach(b => b.setAttribute('aria-expanded', 'false'));
      overlay.addEventListener('transitionend', () => overlay.classList.remove(OPEN_CLASS), { once: true });
    }

    openBtns.forEach(b => b.addEventListener('click', open));
    closeBtns.forEach(b => b.addEventListener('click', close));
    overlay.addEventListener('click', close);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains(OPEN_CLASS)) close();
    });

    // Focus trap
    drawer.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const focusable = Array.from(drawer.querySelectorAll(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(el => !el.disabled && el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  // Re-init after AJAX filter update (Dawn replaces drawer content via FacetFiltersForm)
  document.addEventListener('DOMContentLoaded', initDrawer);
  document.addEventListener('facets:update', initDrawer);
})();
